import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appTrimInputWhiteSpace]'
})
export class TrimInputWhiteSpaceDirective {

  constructor(private el: ElementRef, private control: NgControl) { }
 @HostListener('input', ['$event.target.value'])
  onInput(value: string): void {

    const trimmed = value.trim(); 
    if (value !== trimmed) {
      this.control.control?.setValue(trimmed, { emitEvent: false });
    }
  }
}
